import { h, Component } from "preact";
import { route } from 'preact-router';
import linkState from 'linkstate';
import style from "../../../../../style/admin";

import { getApiPath } from "../../../../../path";
import AdminMenu from "../../../../../components/admin/menu";
import AdminMenuAbout from "../../../../../components/admin/menu/about";

class AdminAboutEditPdf extends Component {
  state = {
    filelist: [],
    formSubmitted: false,
    formValid: false,
    fileTooBig: false,
    formData: {
      pdf: "",
      filename: ""
    }
  };

  constructor(props){
    super(props);
  }

  fileRead = ({ target }) => {
    if(target.files[0].size < 42000000){
      const fileReader = new FileReader();
      fileReader.readAsDataURL(target.files[0]);
      fileReader.onload = (e) => {
        this.state.formData.pdf = e.target.result;
        this.state.formData.filename = target.files[0].name;
      };
      this.setState(previousState => ({
        ...previousState,
        fileTooBig: false
      }));
    }else{
      this.setState(previousState => ({
        ...previousState,
        fileTooBig: true
      }));
    }
  }

  handleSubmit = (event) => {
    event.preventDefault();
    
    this.setState(previousState => ({
      ...previousState,
      formSubmitted: true
    }), this.validateForm());
  }

  validateForm = () => {
    if ( 
      this.state.formData.pdf == "" || this.state.fileTooBig
    ) {
      this.setState(previousState => ({
        ...previousState,
        formValid: false
      }));
    }else{
      this.setState(previousState => ({
        ...previousState,
        formValid: true
      }), this.doSubmit());
    }
  }

  doSubmit = () => {
    let fetchPath = getApiPath(this.props.lang, `adminAbout/pdf`);
    fetch(fetchPath, {
      method: 'post',
      headers: {
        "Authorization": sessionStorage.getItem("vumc-jwt")
      },
      body: JSON.stringify(this.state.formData)
    })
    .then(res => res.json())
    .then(result => {
      if (result.status == 200) {
        window.location.reload();
      } else {
        alert("Something went wrong");
      }
    });
  }
  
  render() {
    return (
      <div class="admin-page">
        <AdminMenu locale={this.props.lang} />
        <AdminMenuAbout locale={this.props.lang} />
        <div>
          <h2>Upload PDF</h2>
          <article>
            <form class="admin-form" onSubmit={this.handleSubmit} enctype="multipart/form-data">

              <div class="form-group">
                <label for="pdf">Selecteer PDF om te uploaden</label>
                <input type="file" name="pdf" id="pdf" accept="application/pdf" onChange={this.fileRead} />
              </div>

              {this.state.fileTooBig &&
                <div class="form-group">
                    De geselecteerde PDF is te groot om toe te voegen
                </div>
              }

              <div class="form-group">
                <button>{this.props.lang=='nl'? 'Opslaan':'Save'}</button>
              </div>
            </form>
          </article>
        </div>
      </div>
    )
  }
}

export default AdminAboutEditPdf;